<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        Validação conta IUGU
      </h1>
      <hr class="linha-amarela" />
    </div>
        <div class="card mb-4">
          <div class="card-body">
            <div class="form-group row g-3">           
              <div class="col-md-12 ">
                <label for="price_range">Valor máximo da venda</label>
                <select required name="bank" v-model="price_range" class="form-control mb-3" id="price_range">
                  <option value="100">Até R$ 100,00</option>
                  <option value="500"> Entre R$ 100,00 e R$ 500,00</option>
                  <option value="600">Mais de R$ 500,00</option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="business_type">Descrição do seu negócio</label>
                <input required v-model="business_type" class="form-control mb-3" id="business_type" placeholder="Descrição do negócio" />
              </div>
              <div class="col-md-6">
                <label for="cnpj">CNPJ</label>
                <input required v-model="cnpj" v-mask="'##.###.###/####-##'" class="form-control mb-3" id="cnpj" placeholder="CNPJ" />
              </div>
              <div class="col-md-6">
                <label for="company_name">Nome da empresa</label>
                <input required v-model="company_name" class="form-control mb-3" id="company_name" placeholder="Nome da empresa" />
              </div>
              <div class="col-md-6">
                <label for="cep">CEP</label>
                <input required v-model="cep" v-mask="'#####-###'" class="form-control mb-3" id="cep" placeholder="CEP" />
              </div>
              <div class="col-md-6">
                <label for="address">Endereço</label>
                <input required v-model="address" class="form-control mb-3" id="address" placeholder="Endereço" />
              </div>
              <div class="col-md-6">
                <label for="city">Cidade</label>
                <input required v-model="city" class="form-control mb-3" id="city" placeholder="Cidade" />
              </div>
              <div class="col-md-6">
                <label for="district">Bairro</label>
                <input required v-model="district" class="form-control mb-3" id="district" placeholder="Bairro" />
              </div>
              <div class="col-md-6">
                <label for="state">Estado</label>
                <input required v-model="state" class="form-control mb-3" id="state" placeholder="Estado" />
              </div>
              <div class="col-md-6">
                <label for="telephone">Telefone</label>
                <input required v-model="telephone" v-mask="'(##) #####-####'" class="form-control mb-3" id="telephone" placeholder="Telefone" />
              </div>
              <div class="col-md-12">
                <label for="resp_name">Nome do Responsável</label>
                <input required v-model="resp_name" class="form-control mb-3" id="resp_name" placeholder="Nome do Responsável" />
              </div>
              <div class="col-md-12">
                <label for="resp_cpf">CPF do Responsável</label>
                <input required v-model="resp_cpf" v-mask="'###.###.###-##'" class="form-control mb-3" id="resp_cpf" placeholder="CPF do Responsável" />
              </div>
              
              <div class="col-md-12">
                <label for="bank">Banco</label>
                <select required name="bank" v-model="bank" class="form-control mb-3" id="bank" @change="validarDigito()">
                  <option value="Itaú">Itaú</option>
                  <option value="Bradesco">Bradesco</option>
                  <option value="Caixa Econômica">Caixa Econômica</option>
                  <option value="Banco do Brasil">Banco do Brasil</option>
                  <option value="Santander">Santander</option>
                  <option value="Banrisul">Banrisul</option>
                  <option value="Sicredi">Sicredi</option>
                  <option value="Sicoob">Sicoob</option>
                  <option value="Inter">Inter</option>
                  <option value="BRB">BRB</option>
                  <option value="Via Credi">Via Credi</option>
                  <option value="Neon">Neon</option>
                  <option value="Votorantim">Votorantim</option>
                  <option value="Nubank">Nubank</option>
                  <option value="Pagseguro">Pagseguro</option>
                  <option value="Banco Original">Banco Original</option>
                  <option value="Safra">Safra</option>
                  <option value="Modal">Modal</option>
                  <option value="Banestes">Banestes</option>
                  <option value="Unicred">Unicred</option>
                  <option value="Money Plus">Money Plus</option>
                  <option value="Mercantil do Brasil">Mercantil do Brasil</option>
                  <option value="JP Morgan">JP Morgan</option>
                  <option value="Gerencianet Pagamentos do Brasil">Gerencianet Pagamentos do Brasil</option>
                  <option value="Banco C6">Banco C6</option>
                  <option value="BS2">BS2</option>
                  <option value="Banco Topazio">Banco Topazio</option>
                  <option value="Uniprime">Uniprime</option>
                  <option value="Stone">Stone</option>
                  <option value="Banco Daycoval">Banco Daycoval</option>
                  <option value="Rendimento">Rendimento</option>
                  <option value="Banco do Nordeste">Banco do Nordeste</option>
                  <option value="Citibank">Citibank</option>
                  <option value="PJBank">PJBank</option>
                  <option value="Cooperativa Central de Credito Noroeste Brasileiro">Cooperativa Central de Credito Noroeste Brasileiro</option>
                  <option value="Uniprime Norte do Paraná">Uniprime Norte do Paraná</option>
                  <option value="Global SCM">Global SCM</option>
                  <option value="Next">Next</option>
                  <option value="Cora">Cora</option>
                  <option value="Mercado Pago">Mercado Pago</option>
                  <option value="Banco da Amazonia">Banco da Amazonia</option>
                  <option value="BNP Paribas Brasil">BNP Paribas Brasil</option>
                  <option value="Juno">Juno</option>
                  <option value="Cresol">Cresol</option>
                  <option value="BRL Trust DTVM">BRL Trust DTVM</option>
                  <option value="Banco Banese">Banco Banese</option>
                  <option value="Banco BTG Pactual">Banco BTG Pactual</option>
                  <option value="Banco Omni">Banco Omni</option>
                  <option value="Acesso Soluções de Pagamento">Acesso Soluções de Pagamento</option>
                  <option value="CCR de São Miguel do Oeste">CCR de São Miguel do Oeste</option>
                  <option value="Polocred">Polocred</option>
                  <option value="Ótimo">Ótimo</option>
                </select>
              </div>
              <div class="col-md-4">
                <label for="bank_ag">Agência da Conta</label>
                <input required v-model="bank_ag" class="form-control mb-3" id="bank_ag" placeholder="Agência da Conta" />
              </div>
              <div class="col-md-2" v-if="cc_agencia == true">
                <label for="bank_cc_digit">Digito da agência</label>
                <input required v-model="bank_ag_digit" v-mask="'###'" class="form-control mb-3" placeholder="Digito da agência" />
              </div>
              <div class="col-md-4">
                <label for="bank_cc">Número da conta</label>
                <input required v-model="bank_cc" v-mask="'##############'" class="form-control mb-3" id="bank_cc" placeholder="Número da conta" />
              </div>
              <div class="col-md-2" v-if="cc_conta == true">
                <label for="bank_cc_digit">Digito da conta</label>
                <input required v-model="bank_cc_digit" v-mask="'###'" class="form-control mb-3" id="bank_cc_digit" placeholder="Número da conta" />
              </div>
              <div class="col-md-12">
                <label for="account_type">Tipo da conta</label>
                <select required v-model="account_type" class="form-control mb-3" name="account_type" id="account_type">
                  <option value="Corrente">Corrente</option>
                  <option value="Poupança">Poupança</option>
                </select>
              </div>

                <b-button @click="send()" type="submit" class="col-12 mt-3 btn-success">Validar Conta</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'cotacao-pagamento',
  data() {
    return {
      price_range: '600',
      business_type: '',
      cnpj: '',
      company_name: '',
      address: '',
      cep: '',
      city: '',
      district: '',
      state: '',
      telephone: '',
      resp_name: '',
      resp_cpf: '',
      bank: '',
      bank_ag: '',
      bank_ag_digit: '',
      account_type: '',
      bank_cc: '',
      bank_cc_digit: '',
      cc_agencia: false,
      cc_conta: true,
      agencia: [
        'Banco do Brasil',
        'Bradesco',
        'Rendimento',
        'Next',
        'VORTX DTVM LTDA',
        'Banco ABC Brasil'
      ],
      conta: [
        'CCR de São Miguel do Oeste',
        'Citibank'
      ]
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      setValidation: (state) => state.setValidation,
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },

  beforeMount() {
    this.cnpj = this.dadosUsuario.cnpj;
    this.company_name = this.dadosUsuario.informacoes.razao_social;
    this.address = this.dadosUsuario.informacoes.endereco;
    this.cep = this.dadosUsuario.informacoes.cep;
    this.city = this.dadosUsuario.informacoes.cidade.nome;
    this.district = this.dadosUsuario.informacoes.bairro;
    this.state = this.dadosUsuario.informacoes.estado.uf;
    this.telephone = this.dadosUsuario.informacoes.celular;
    this.resp_name = this.dadosUsuario.informacoes.nome_responsavel;
    this.resp_cpf = this.dadosUsuario.cpf
  },

  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    validarDigito() {
      this.cc_conta = true;
      this.cc_agencia = false;
      this.bank_ag = '';
      this.bank_ag_digit = '';
      this.bank_cc = '';
      this.bank_cc_digit = '';

      if(this.agencia.indexOf(this.bank) !== -1) {
        this.cc_agencia = true;
      }

      if(this.conta.indexOf(this.bank) !== -1) {
        this.cc_conta = false;
      }
    },
    dataValidation(){ 
      if(
        !this.checkIsEmpty(this.bank_cc) &&
        !this.checkIsEmpty(this.price_range) &&
        !this.checkIsEmpty(this.business_type) &&
        !this.checkIsEmpty(this.cnpj) &&
        !this.checkIsEmpty(this.company_name) &&
        !this.checkIsEmpty(this.address) &&
        !this.checkIsEmpty(this.cep) &&
        !this.checkIsEmpty(this.city) &&
        !this.checkIsEmpty(this.state) &&
        !this.checkIsEmpty(this.telephone) &&
        !this.checkIsEmpty(this.resp_name) &&
        !this.checkIsEmpty(this.bank) &&
        !this.checkIsEmpty(this.bank_ag) &&
        !this.checkIsEmpty(this.account_type) &&
        !this.checkIsEmpty(this.company_name) &&
        !this.checkIsEmpty(this.district)
        ){
        return true;
      }
      return false;
    },
    send() {
      if(this.dataValidation()){
        try {
          var bankcc = '';
          var agenciacc = '';
          if(this.cc_conta == true) {
            bankcc = `${this.bank_cc}-${this.bank_cc_digit}`;
          } else {
            bankcc = this.bank_cc;
          }

          if(this.cc_agencia == true) {
            agenciacc = `${this.bank_ag}-${this.bank_ag_digit}`;
          } else {
            agenciacc = this.bank_ag;
          }

          const data = {
            price_range: this.price_range,
            business_type: this.business_type,
            cnpj: this.cnpj,
            company_name: this.company_name,
            address: this.address,
            cep: this.cep,
            city: this.city,
            district: this.district,
            state: this.state,
            telephone: this.telephone,
            resp_name: this.resp_name,
            resp_cpf: this.resp_cpf,
            bank: this.bank,
            bank_ag: agenciacc,
            account_type: this.account_type,
            bank_cc: bankcc,
            name: this.company_name,
          };
          this.$store
            .dispatch('sendValidation', data)
            .then(() => {
              this.makeToast('Opa!', 'Validação enviada com sucesso. Aguarde!', 'success');
              setTimeout(() => {
                this.$root.$emit('valid-available-app');
                this.$router.push({ name: 'lojista-iugu-dash' });
              }, 1000);
            })
            .catch(() => {
              this.makeToast(
                'Oops!',
                'Aconteceu um erro. Tente novamente mais tarde',
                'danger'
              );
            });
        } catch (e) {
          this.makeToast(
            'Oops!',
            'Aconteceu um erro. Tente novamente mais tarde',
            'danger'
          );
        }
      } else {
         this.makeToast(
            'Oops!',
            'Favor preencher todos os campos!',
            'danger'
          );
      }
    },
  },
};
</script>
